import React from 'react';
import { useController, useFormContext } from 'react-hook-form';
import TopFieldContent from '../../../../../Components/Form/components/TopFieldContent';
import useFormName from '../../../../../Hooks/useFormName';
import ErrorMessage from '../../../../../Components/Form/components/ErrorMessage';
import { SelectValue } from '../../../../../Components/Base/Select/Select';
import P1MedicalRequestType from './P1MedicalRequestType';

interface Props {
	name: string;
	label?: string;
	isRequired?: boolean;
	className?: string;
	onChange?: (value: SelectValue) => void;
}

const P1MedicalRequestTypeField: React.FC<Props> = ({
	name,
	label,
	className,
	isRequired,
}) => {
	const { fieldName } = useFormName({ name });
	const { control } = useFormContext();

	const {
		field,
		fieldState: { error },
	} = useController({
		control,
		name: fieldName,
	});

	return (
		<div className={className}>
			{label && <TopFieldContent label={label} isRequired={isRequired} />}
			<P1MedicalRequestType {...field} />
			{error?.message && <ErrorMessage tx={error.message} />}
		</div>
	);
};

export default P1MedicalRequestTypeField;
